import { breakpoints } from '../styles/muiThemeConfig'

const fontSizes = {
	xs: 10,
	sm: 12,
	md: 13,
	lg: 14,
	xl: 16,
}

export const getFontSize = () => {
	const width = window.innerWidth
	if (width >= breakpoints.xl) return fontSizes.xl
	if (width >= breakpoints.lg) return fontSizes.lg
	if (width >= breakpoints.md) return fontSizes.md
	if (width >= breakpoints.sm) return fontSizes.sm
	return fontSizes.xs
}
